import React, { useEffect } from 'react';
import { Download, X } from 'lucide-react';

const PDFViewerModal = ({ isOpen, pdfPath, pdfName, onClose }) => {
  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  if (!isOpen) {
    return null;
  }

  const viewerUrl = pdfPath
    ? `${pdfPath}${pdfPath.includes('#') ? '&' : '#'}toolbar=0&navpanes=0&scrollbar=0&view=FitH`
    : '';

  const handleDownload = () => {
    if (!pdfPath) return;
    const link = document.createElement('a');
    link.href = pdfPath;
    link.download = pdfName || 'document.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.55)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999
    }} onClick={onClose}>
      <div
        style={{
          width: 'min(96vw, 1200px)',
          height: '90vh',
          backgroundColor: '#ffffff',
          borderRadius: '12px',
          overflow: 'hidden',
          boxShadow: '0 30px 70px rgba(0, 0, 0, 0.35)',
          position: 'relative'
        }}
        onClick={(event) => event.stopPropagation()}
      >
        {pdfPath ? (
          <button
            type="button"
            onClick={handleDownload}
            style={{
              position: 'absolute',
              top: '12px',
              right: '52px',
              zIndex: 2,
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              border: '1px solid #cbd5e1',
              borderRadius: '10px',
              backgroundColor: 'rgba(255, 255, 255, 0.95)',
              color: '#0f172a',
              fontWeight: 600,
              padding: '8px 10px',
              cursor: 'pointer'
            }}
          >
            <Download size={14} />
            Download
          </button>
        ) : null}
        <button
          type="button"
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '12px',
            right: '12px',
            zIndex: 2,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: '1px solid #cbd5e1',
            borderRadius: '10px',
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            color: '#0f172a',
            width: '34px',
            height: '34px',
            cursor: 'pointer'
          }}
          aria-label="Close PDF preview"
        >
          <X size={16} />
        </button>
        {viewerUrl ? (
          <iframe
            src={viewerUrl}
            style={{
              width: '100%',
              height: '100%',
              border: 'none'
            }}
            title={pdfName || 'PDF Viewer'}
          />
        ) : (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            color: '#64748b'
          }}>
            No PDF available
          </div>
        )}
      </div>
    </div>
  );
};

export default PDFViewerModal;
